import FetchJSON from './fetch';

export function getDictionary(route, callback) {
  let url = `/api/dictionary/item?path=${route}`;

  FetchJSON.fetch(url, 'GET').then((responseJson) => {
    if (responseJson.Message) callback({ error: true, response: responseJson });
    callback(responseJson);
  });
}

export function getText(route, dictionary) {
  let item = null;

  // Split the route into array to loop through.
  route = route.split('/');

  // Get the last route item as that is the actual dictionary name.
  const name = route[route.length - 1];
  // Remove that from the route array as route would just be sub folders.
  route.splice(-1, 1);

  if (dictionary) {
    // Go through sub folders and set dictionary to the relavent folder.
    if (route.length > 0) {
      route.forEach((value) => {
        dictionary = findValue(value, dictionary.SubFolders);
      });
    }
    // Get the actual value of the dictionary item.
    if (dictionary) item = findValue(name, dictionary.Entries);
  }

  // Return the phrase. If not found then return a readable route path as placeholder.
  return item === null ? `${route.join(' ')} ${name}` : item.Phrase;
}

// Loops through array and returns the item that matches the given name.
function findValue(folderName, folders) {
  let selectedItem = null;
  folders.forEach(item => {
    if (item.Name.toLowerCase() === folderName.toLowerCase()) selectedItem = item;
  });
  return selectedItem;
}
